import * as React from "react"
import { BarChart } from '@mui/x-charts/BarChart';
import { Box, } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop";
import dayjs from "dayjs"

export default function CheckoutCheckinActivityReport({ startDatetime, endDatetime, selectedLocations }) {
    const [isLoading, setIsLoading] = React.useState(false)
    const [checkoutCheckinData, setCheckoutCheckinData] = React.useState([])

    const getCheckoutCheckinActivity = (start_datetime, end_datetime, location_ids) => {
        if (!location_ids || location_ids.length === 0) {
            return
        }
        setIsLoading(true)
        send_authorized_request(() => AXIOS_API_INSTANCE.get("reports/checkoutcheckinactivity", {
            params: {
                start_datetime: start_datetime,
                end_datetime: end_datetime.add(1, 'day'),
                location_ids: location_ids
            },
        }).then((checkoutCheckin) => {
            setCheckoutCheckinData(checkoutCheckin.data.data)
            setIsLoading(false)
        })
        )
    }

    React.useEffect(() => {
        getCheckoutCheckinActivity(startDatetime, endDatetime, selectedLocations.map((x) => x.id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDatetime, endDatetime, selectedLocations])

    const days = []
    for (let i = startDatetime; i <= endDatetime; i = i.add(1, 'day')) {
        days.push(i.startOf('day'))
    }
    const contracts_series = [
        { data: [], stack: 'A', label: 'Reservations Created' },
        { data: [], stack: 'A', label: 'Contracts Checked Out' },
        { data: [], stack: 'A', label: 'Contracts Checked In' },
    ]
    const contract_items_series = [
        { data: [], stack: 'A', label: 'Item Reservations Created' },
        { data: [], stack: 'A', label: 'Items Checked Out' },
        { data: [], stack: 'A', label: 'Items Checked In' },
    ]
    const band_names = []

    days.forEach((day) => {
        const day_events = checkoutCheckinData.filter((x) => {
            const date = dayjs.utc(x.date_created)
            return date.date() === day.date() && date.month() === day.month() && date.year() === day.year()
        })
        band_names.push(day.format('M/D/YYYY'))
        contracts_series[0].data.push(day_events.filter((x) => x.event_type === 'RESERVE').length)
        contracts_series[1].data.push(day_events.filter((x) => x.event_type === 'CHECK_OUT').length)
        contracts_series[2].data.push(day_events.filter((x) => x.event_type === 'CHECK_IN').length)
        contract_items_series[0].data.push(day_events.filter((x) => x.event_type === 'RESERVE').reduce((a, b) => a + b.rental_contract_item_quantity, 0))
        contract_items_series[1].data.push(day_events.filter((x) => x.event_type === 'CHECK_OUT').reduce((a, b) => a + b.rental_contract_item_quantity, 0))
        contract_items_series[2].data.push(day_events.filter((x) => x.event_type === 'CHECK_IN').reduce((a, b) => a + b.rental_contract_item_quantity, 0))
    })

    return (
        (<React.Fragment>
            <Box>
                <LoadingBackdropIndeterminate
                    open={isLoading}
                    text="Loading Activity Report"
                />
                {!isLoading && checkoutCheckinData.length === 0 &&
                    <h3>NO DATA</h3>
                }
                {!isLoading && checkoutCheckinData.length > 0 &&
                    <Grid container>
                        <Grid size="grow">
                            <BarChart
                                xAxis={[
                                    {
                                        scaleType: 'band',
                                        data: band_names
                                    }]}
                                series={contracts_series}
                                width={600}
                                height={350}
                            />

                        </Grid>
                        <Grid size="grow">
                            <BarChart
                                xAxis={[
                                    {
                                        scaleType: 'band',
                                        data: band_names
                                    }]}
                                series={contract_items_series}
                                width={600}
                                height={350}
                            />

                        </Grid>
                    </Grid>
                }
            </Box>
        </React.Fragment>)
    );
}
